import { xxhash32 } from 'hash-wasm';

export default async function hash(s: string): Promise<string> {
  return await xxhash32(s);
}
